import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem, makeStringProp, makeArrayProp } from '@/utils';

const { name, bem } = createNamespaceBem('card-member');

const cardMemberProps = {
  avatar: makeStringProp(''), // avatar
  title: makeStringProp(''), // 医生姓名
  tags: makeArrayProp<string>(), // ['副主任医师', '皮肤科']
  bodyInfo: makeStringProp(''), // 个人介绍
  bodyInfoLabel: makeStringProp(''),
};

export type CardMemberProps = ExtractPropTypes<typeof cardMemberProps>;

export default defineComponent({
  name,
  props: cardMemberProps,
  setup(props) {
    return () => (
      <div class={bem()}>
        <div class={bem('title')}>
          <img class={bem('avatar')} src={props.avatar} />
          <div class={bem('info')}>
            <div class={bem('name')}>{props.title}</div>
            <div class={bem('tags')}>
              {props.tags.map((i) => (
                <div class={bem('tag')}>{i}</div>
              ))}
            </div>
          </div>
        </div>
        <div class={bem('desc')}>
          {props.bodyInfoLabel}
          {props.bodyInfo}
        </div>
      </div>
    );
  },
});
